/** Returns whether provided feature flag is enabled for current company. */
export const isFeatureEnabledSelector = (state, feature) => state.featureFlags.features[feature]

export const companyOptionsSelector = state => state.current_user.company_options
